import { Component, Input, HostBinding, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'suka-card',
  template: `
    <suka-card-header
      *ngIf="title"
      (action)="onHeaderAction($event)"
      [actionLabel]="headerActionLabel"
      [skeleton]="skeleton"
    >
      {{title}}
    </suka-card-header>

    <suka-card-section
      *ngIf='(sectioned !== false) else elseTpl'
    >
      <ng-container *ngTemplateOutlet="elseTpl"></ng-container>
    </suka-card-section>

    <suka-card-footer
      *ngIf='!skeleton && showFooter'
      (primaryAction)="onPrimaryFooterAction($event)"
      [primaryLabel]="primaryFooterActionLabel"
      (secondaryAction)="secondaryFooterAction ? onSecondaryFooterAction($event): undefined"
      [secondaryLabel]="secondaryFooterActionLabel"
    >
    </suka-card-footer>

    <ng-template #elseTpl><ng-content></ng-content></ng-template>
  `
})

// tslint:disable-next-line: component-class-suffix
export class Card implements OnInit {
  /**
   * Title content for the card.
   */
  @Input() title: string;

  /**
   * Set to `true` to auto-wrap content in section
   */
  @Input() sectioned: boolean;

  /**
   * Primary action in the card footer.
   */
  @Input() primaryFooterActionLabel: string;
  @Output() primaryFooterAction = new EventEmitter();

  /**
   * Secondary action in the card footer.
   */
  @Input()  secondaryFooterActionLabel: string;
  @Output() secondaryFooterAction = new EventEmitter();

  /**
   * Action in the card header.
   */
  @Input() headerActionLabel: string;
  @Output() headerAction = new EventEmitter();

  @HostBinding('class.card') cardClass = true;

  /**
   * Skeleton state.
   */
  @Input() skeleton = false;

  showFooter = false;

  public ngOnInit() {
    this.showFooter = this.primaryFooterAction.observers.length > 0;
  }

  public onPrimaryFooterAction($event) {
    this.primaryFooterAction.emit($event);
  }

  public onSecondaryFooterAction($event) {
    this.secondaryFooterAction.emit($event);
  }

  public onHeaderAction($event) {
    this.headerAction.emit($event);
  }
}
